import type { WidgetTemplateComponentType } from "@src/interface/Widget";

/** Chunk async isolé : un fichier loader = un groupe de split webpack distinct du composé Landing. */
export default (): Promise<{ default: WidgetTemplateComponentType<any> }> =>
  import(
    /* webpackChunkName: "lst-tpl-about" */
    "../templates/about"
  );
